import { Component, ComponentRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { SafeHtmlUtils } from '../../../../../utils/safe-html.util';
import { DocumentService } from 'src/app/services/document/document.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { MSS_EMAIL_REGEX } from 'src/app/utils/interfaces/new/mss-email-authent.interface';
import { MSSAddress,
  MSSAttachment,
  MSSEnumFlag,
  MSSEnumReplyType,
  MSSEnumTypeMail,
  MSSMessage,
  MSSMessagePatientInfo,
  MSSMessageToSend,
} from 'src/app/utils/interfaces/new/mss-message.interface';
import { MssRecipientSearchComponent } from '../mss-recipient-search/mss-recipient-search.component';
import moment from 'moment';
import { PatientService } from 'src/app/services/patient/patient.service';
import { Subscription } from 'rxjs';
import { MssServiceFactory } from 'src/app/services/mss/mss-service.factory';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { InsRealservice } from 'src/app/services/ins/ins.service';
import { QuillEditorBase } from 'ngx-quill';
import { Profil } from 'src/app/utils/interfaces/new/profil.interface';
import { Utilisateur } from 'src/app/utils/interfaces/new/utilisateur.interface';
import { InfosPatient } from 'src/app/utils/interfaces/new/infos-patient.interface';

interface MMSMessageSender {
  name?: string;
  email: string;
}

@Component({
  selector: 'app-mss-message-display',
  templateUrl: './mss-message-display.component.html',
  styleUrls: ['./mss-message-display.component.scss']
})
export class MssMessageDisplayComponent implements OnInit {

  public static readonly titlePrefix = 'XDM/1.0/DDM+';

  @Input() public set message(msg: MSSMessage) {
    this.messageDisplay = msg;
    // Reset le mode de reponse car le composant ne se reload pas entierement.
    this._replyType = undefined;
    this._initData();
  }
  public get message(): MSSMessage {
    return this.messageDisplay;
  }
  @Input() public balSender: string;
  @Input() public idNat: string;

  @Output() public doDownloadAttachment = new EventEmitter<MSSAttachment>();
  @Output() public doAddAttachmentToPatient = new EventEmitter<MSSAttachment>();
  @Output() public doDeleteMessage = new EventEmitter<MSSMessage>();
  @Output() public doSaveDraft = new EventEmitter<MSSMessageToSend>();
  @Output() public doSendMessage = new EventEmitter<MSSMessageToSend>();
  @Output() public doExtend = new EventEmitter<boolean>();
  @Output() public doUnselectMessage = new EventEmitter<void>();

  private messageDisplay: MSSMessage;
  public senderName: MMSMessageSender;
  public messageBodySanitized: any;
  public selectedAttachmentPart: number;
  public formGroup: FormGroup;
  private _initialMessage: MSSMessage;
  protected _replyType: MSSEnumReplyType;
  public messageToAddress: Array<MSSAddress> = [];
  public messageCcAddress: Array<MSSAddress> = [];
  public messageBccAddress: Array<MSSAddress> = [];
  public isExtend = false;
  public mssEnumFlag = MSSEnumFlag;
  public currentMessagePatient: MSSMessagePatientInfo;
  public canDraftMessage = false;

  constructor(
    private _sanitizer: DomSanitizer,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _formBuilder: FormBuilder,
    private _documentSrv: DocumentService,
    private _mssSrv: MssServiceFactory,
    private _patientSrv: PatientService,
    private _strUtilsSrv: StringUtilsService,
    private _insSrv: InsRealservice
  ) {
    this.canDraftMessage = this._mssSrv.getService().canDraftMessage();
  }

  ngOnInit(): void {
  }

  public downloadAttachment(attachment: MSSAttachment): void {
    this.doDownloadAttachment.emit(attachment);
  }

  public addAttachmentToPatient(attachment: MSSAttachment): void {
    this.doAddAttachmentToPatient.emit(attachment);
  }

  public deleteDraftAttachment(attachment: MSSAttachment): void {
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Suppression',
      'Voulez-vous supprimer cette pièce jointe ?'
    );

    const sub = modal.instance.closeEmitter.subscribe(async (res) => {
      const loading = this._modalSrv.openLoading(this._viewContainerRef);

      try {
        if (res) {
          if (attachment.part && this._mssSrv.getService().canRemoveAttachment()) {
            await this._mssSrv.getService().removeAttachment(
              { email: this.balSender, idNat: this.idNat },
              this.message.messageId,
              attachment
            );
          }

          this.message.attachments.splice(
            this.message.attachments.findIndex(a => a.part === attachment.part && a.fileName === attachment.fileName),
            1
          );

          if (attachment.part) {
            for (const att of this.message.attachments) {
              if (att.part && att.part > attachment.part) {
                att.part--;
              }
            }
          }
        }
      } catch (e) {
      } finally {
        sub.unsubscribe();
        loading.destroy();
      }
    });
  }

  public cancelDraft(message: MSSMessage): void {
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Annuler',
      'Voulez-vous annuler cette saisie ?'
    );

    const sub = modal.instance.closeEmitter.subscribe((res) => {
      if (res) {
        const msgTmp = {...this._initialMessage};
        if (msgTmp.attachments && msgTmp.attachments.length > 0) {
          const draftFlagIndex = msgTmp.flags.findIndex(f => f === MSSEnumFlag.DRAFT);
          if (draftFlagIndex !== -1) {
            msgTmp.flags.splice(draftFlagIndex, 1);
          }
        }
        this.message = msgTmp;
      }
      sub.unsubscribe();
    });
  }

  public saveDraft(): void {
    if (!this.canDraftMessage) {
      return;
    }

    const message: MSSMessageToSend = this._getMessageToSendFromForm(true);
    if (message) {
      // delete message.patientInfo;
      this.doSaveDraft.emit(message);
    }
  }

  public sendMessage(): void {
    const message: MSSMessageToSend = this._getMessageToSendFromForm();
    if (message) {
      // delete message.patientInfo;
      this.doSendMessage.emit(message);
    }
  }


  public selectAttachment(attachmentPart: number): void {
    if (!this.selectedAttachmentPart) {
      this.selectedAttachmentPart = attachmentPart;
    } else {
      this.selectedAttachmentPart = undefined;
    }
  }

  public askBeforeDelete(): void {
    const modal = this._modalSrv.openModalConfirmation(
      this._viewContainerRef,
      'Suppression',
      'Voulez-vous supprimer ce message ?'
    );

    const sub = modal.instance.closeEmitter.subscribe((res) => {
      if (res) {
        this.doDeleteMessage.emit(this.message);
        this.doUnselectMessage.emit();
      }
      sub.unsubscribe();
    });
  }

  public messageAction(actions: 'reply' | 'replyToAll' | 'forward'): void {
    if (actions === 'reply') {
      this._initialMessage = {...this.message};
      const addresses: Array<MSSAddress> = [];
      for (const address of this.message.addresses) {
        if (address.type === MSSEnumTypeMail.FROM) {
          addresses.push({
            email: address.email,
            type: MSSEnumTypeMail.TO,
            name: address.name
          });
          break;
        }
      }

      this.message = {
        date: new Date(),
        folderId: this.message.folderId,
        messageId: this.message.messageId,
        size: this.message.size,
        subject: `Re : ${this.message.subject}`,
        attachments: [],
        addresses,
        flags: [MSSEnumFlag.DRAFT]
      };

      this._replyType = MSSEnumReplyType.REPLIED;

      this._initData();
    } else if (actions === 'replyToAll') {
      this._initialMessage = {...this.message};
      const addresses: Array<MSSAddress> = [];
      for (const address of this.message.addresses) {
        addresses.push({
          email: address.email,
          type: address.type === MSSEnumTypeMail.FROM ? MSSEnumTypeMail.TO : MSSEnumTypeMail.CC,
          name: address.name
        });
      }

      this.message = {
        date: new Date(),
        folderId: this.message.folderId,
        messageId: this.message.messageId,
        size: this.message.size,
        subject: `Re : ${this.message.subject}`,
        attachments: [],
        addresses,
        flags: [MSSEnumFlag.DRAFT]
      };

      this._replyType = MSSEnumReplyType.REPLIED;

      this._initData();
    } else if (actions === 'forward') {
      this._initialMessage = {...this.message};
      const addresses: Array<MSSAddress> = [];

      this.message = {
        date: new Date(),
        folderId: this.message.folderId,
        messageId: this.message.messageId,
        size: this.message.size,
        subject: `Fwd : ${this.message.subject}`,
        attachments: [],
        addresses,
        flags: [MSSEnumFlag.DRAFT]
      };

      this._replyType = MSSEnumReplyType.FORWARDED;

      this._initData();
    }
  }

  public findRecipients(recipientType: 'messageRecipients' | 'messageCcRecipients' | 'messageBccRecipients'): void {
    const modal = this._modalSrv.openModal<MssRecipientSearchComponent>(
      this._viewContainerRef,
      MssRecipientSearchComponent
    ) as ComponentRef<MssRecipientSearchComponent>;

    const sub = modal.instance.closeEmitter.subscribe((res: string) => {
      if (res && res !== '') {
        let inputValue = this.formGroup.get(recipientType).value;
        inputValue += (inputValue !== '' ? ',' : '')  + res;
        this.formGroup.get(recipientType).setValue(inputValue);
      }
      modal.destroy();
      sub.unsubscribe();
    });
  }

  public findPatient(): void {
    const modal = this._modalSrv.openModalSearchPatient(this._viewContainerRef);
    const sub = modal.instance.closeEmitter.subscribe(async (idPatient: string) => {
      let patientInfosForMss = null;
      if (idPatient) {
        const patient = await this._patientSrv.findOnePatientInfos(idPatient);
        const couverture = await this._patientSrv.findOnePatientCouverture(idPatient);
        patientInfosForMss = patient;
        const inputValue = `${this._strUtilsSrv.uppercaseFirstCharString(patient.prenom)} ${patient.nom.toLocaleUpperCase()}`;
        this.currentMessagePatient = {
          patientId: idPatient,
          firstName: this._strUtilsSrv.uppercaseFirstCharString(patient.prenom),
          lastName: patient.nom.toLocaleUpperCase(),
          birthDate: patient.dateNaissance,
          couverture
        };
        this.formGroup.get('messagePatient').setValue(inputValue);
      }
      this._modalSrv.close(modal);
      sub.unsubscribe();
      if (this.currentMessagePatient && patientInfosForMss) {
        // EXIGENCE Cas 1 & 2 : Logique INS
        const isQualifie = patientInfosForMss.identiteStatutId === '95a6081f-5260-44b8-9661-e4795e1cfcaf';
        const isRecupere = patientInfosForMss.identiteStatutId === '8ba51292-17bb-4215-93bc-0ac6217655a1';

        const ins = this.currentMessagePatient.couverture?.ins;
        const insKeyToUse = patientInfosForMss.insKey || this.currentMessagePatient.couverture?.insKey || '';

        if (isQualifie || isRecupere) {
          // Cas 1 : L'identité est qualifiée ou récupérée, on génère directement l'adresse MSS
          if (ins && this.currentMessagePatient.couverture.oid) {
            const mssAddress = `${ins}${insKeyToUse}@patient.mssante.fr`;
            this.currentMessagePatient.mssAddress = mssAddress;

            // Injection automatique dans le champ "Destinataires"
            let inputValue = this.formGroup.get('messageRecipients').value as string;
            inputValue += (inputValue !== '' ? ',' : '') + mssAddress;
            this.formGroup.get('messageRecipients').setValue(inputValue);
          } else {
            this._showMissingInsAlert();
          }
        } else {
          // Cas 2 : Identité non qualifiée/récupérée, on effectue les vérifications du NIR
          if (ins && insKeyToUse) {
            const isValidNir = this._insSrv.validateNirAndCrossCheck(ins, insKeyToUse, patientInfosForMss.sexe, patientInfosForMss.dateNaissance);
            
            if (isValidNir) {
              // Modale de confirmation (Identitovigilance)
              const dateNaissanceStr = moment(patientInfosForMss.dateNaissance, ['YYYY-MM-DD', 'DD/MM/YYYY']).format('DD/MM/YYYY');
              const modal = this._modalSrv.openModalConfirmation(
                this._viewContainerRef,
                'Confirmation d\'envoi au patient',
                `L'identité de ce patient n'est pas qualifiée.\n\nAfin d'éviter tout envoi erroné, veuillez confirmer que le sexe et la date de naissance de ce patient sont bien :\n\n- Sexe : ${patientInfosForMss.sexe || 'Non renseigné'}\n- Date de naissance : ${dateNaissanceStr}\n\nConfirmez-vous ces informations pour générer l'adresse de messagerie ?`
              );

              const subConfirm = modal.instance.closeEmitter.subscribe((isConfirmed: boolean) => {
                if (isConfirmed) {
                  const mssAddress = `${ins}${insKeyToUse}@patient.mssante.fr`;
                  this.currentMessagePatient.mssAddress = mssAddress;

                  let inputValue = this.formGroup.get('messageRecipients').value as string;
                  inputValue += (inputValue !== '' ? ',' : '') + mssAddress;
                  this.formGroup.get('messageRecipients').setValue(inputValue);
                }
                subConfirm.unsubscribe();
                modal.destroy();
              });
            } else {
              this._modalSrv.openAlert(
                this._viewContainerRef,
                'Identité invalide',
                'Le NIR de ce patient est invalide ou ne correspond pas aux informations de son dossier (sexe, date de naissance). Il est impossible de lui envoyer un message.'
              );
            }
          } else {
            this._showMissingInsAlert();
          }
        }
      }
    });
  }

  private _showMissingInsAlert(): void {
    this._modalSrv.openAlert(
      this._viewContainerRef,
      'Attention',
      'Ce patient ne possède pas de INS (NIR) complet dans sa fiche patient, il sera impossible d\'envoyer un document de santé le concernant.\n\n' +
      'Si vous voulez envoyer un document de santé, veuillez choisir un autre patient ou completer la fiche de ce patient.'
    );
  }

  public async selectDocuments(): Promise<void> {
    try {
      const body = document.getElementsByTagName('body')[0];
      const inputElem = document.createElement('input');
      inputElem.type = 'file';
      inputElem.setAttribute('multiple', 'true');
      body.appendChild(inputElem);
      inputElem.click();
      inputElem.addEventListener('change', async (event: any) => {

        if (!this.message.attachments) {
          this.message.attachments = [];
        }

        const files = event.target.files as FileList;
        // TODO Ne pas rajoute de document après un document de santé
        if (files.length > 0 && this.message.attachments.find(a => a.clinicalDocument)) {
          this._modalSrv.openAlert(
            this._viewContainerRef,
            'Erreur',
            'Impossible d\'ajouter plus de documents à un message contenant déjà un document de santé. Veuillez le supprimer avant.'
            );
          return;
        }
        // TODO Uniquement un seul document de santé à la fois
        if (files.length === 1) {
          // On vérifie que le total des PJ ne dépasse pas 10Mo (10485760 octets)
          let filesWeight = 0;
          for (let i = 0; i < files.length; i++) {
            filesWeight += files.item(i).size;
          }
          if (filesWeight > 10485760) {
            this._modalSrv.openAlert(
              this._viewContainerRef,
              'Erreur',
              `Les pièces jointes sélectionnées sont trop lourdes pour être ajoutées à ce message (max 10Mo). Veuillez les réduire.`
            );
            return;
          }

          for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            if (this.currentMessagePatient
            && this.currentMessagePatient.couverture
            && this.currentMessagePatient.couverture.ins
            && this.currentMessagePatient.couverture.oid) {
              const modal = this._modalSrv.openModalConfirmation(
                this._viewContainerRef,
                'Document de santé',
                `La pièce jointe "${file.name}" est-elle un document de santé ?`
              );
              let sub: Subscription;
              await new Promise<void>((resolve => {
                sub = modal.instance.closeEmitter.subscribe(async (res) => {
                  if (res) {
                    this.message.attachments.push({
                      clinicalDocument: true,
                      contentType: file.type,
                      fileName: file.name,
                      file: await this._documentSrv.convertFileToBase64(file),
                    });
                  } else {
                    this.message.attachments.push({
                      clinicalDocument: false,
                      contentType: file.type,
                      fileName: file.name,
                      file: await this._documentSrv.convertFileToBase64(file),
                    });
                  }
                  console.log(JSON.parse(JSON.stringify(this.message.attachments)));
                  resolve();
                });
              }));
              if (sub) {
                sub.unsubscribe();
              }
            } else {
              this.message.attachments.push({
                clinicalDocument: false,
                contentType: file.type,
                fileName: file.name,
                file: await this._documentSrv.convertFileToBase64(file),
              });
            }
          }
          body.removeChild(inputElem);
          console.log(JSON.parse(JSON.stringify(this.message.attachments)));
          /**
           * À chaque ajout d'un document par l'utilisateur on enregistre le message.
           *
           * Ceci à pour intêret de :
           * - toujours avoir la dernière version du message que l'utilisateur veut
           * - savoir si la/les pièce(s) jointe(s) est/sont trop lourde(s) pour l'enregistrement
           *          (afin que l'utilisateur n'en soit pas informé au dernier moment)
           */
          this.saveDraft();
        } else {
          this._modalSrv.openAlert(
            this._viewContainerRef,
            'Erreur',
            'Actuellement, il est impossible d\'ajouter plusieurs documents à un message.'
          );
        }
      });
    } catch (e) {
      this._modalSrv.openAlert(
        this._viewContainerRef,
        'Erreur',
        'Une erreur est survenur lors de l\'importation de ce(s) fichier(s)'
      );
    }
  }

  public extendMessageZone(doExtend: boolean): void {
    this.isExtend = doExtend;
    this.doExtend.emit(doExtend);
  }

  public getMessageDate(message: MSSMessage): Date {
    return moment(message.date, 'DD/MM/YYYY HH:mm:ss').toDate();
  }

  private _initData(): void {
    if (this.message.flags && this.message.flags.includes(MSSEnumFlag.DRAFT) && !this._initialMessage) {
      this._initialMessage = {...this.message};
    }

    this.messageToAddress = [];
    this.messageCcAddress = [];
    this.messageBccAddress = [];
    if (this.message.addresses) {
      for (const address of this.message.addresses) {
        if (address.type === MSSEnumTypeMail.FROM) {
          this.senderName = {
            name: address.name ? address.name : undefined,
            email: address.email
          };
        } else if (address.type === MSSEnumTypeMail.TO) {
          this.messageToAddress.push(address);
        } else if (address.type === MSSEnumTypeMail.CC) {
          this.messageCcAddress.push(address);
        } else if (address.type === MSSEnumTypeMail.BCC) {
          this.messageBccAddress.push(address);
        }
      }
    }

    if (this.message.body) {
      this.messageBodySanitized = SafeHtmlUtils.sanitizeHtmlAndBypass(this.message.body, this._sanitizer);
    }

    if (this.message.flags && this.message.flags.includes(MSSEnumFlag.DRAFT)) {
      setTimeout(() => {
        let addresses = '';
        let ccAddresses = '';
        let bccAddresses = '';
        if (this.message && this.message.addresses && this.message.addresses.length > 0) {
          const addressesArr: Array<string> = [];
          const ccAddressesArr: Array<string> = [];
          const bccAddressesArr: Array<string> = [];
          for (const address of this.message.addresses) {
            if (address.type === MSSEnumTypeMail.TO) {
              addressesArr.push(address.email);
            } else if (address.type === MSSEnumTypeMail.CC) {
              ccAddressesArr.push(address.email);
            } else if (address.type === MSSEnumTypeMail.BCC) {
              bccAddressesArr.push(address.email);
            }
          }
          addresses = addressesArr.join(',');
          ccAddresses = ccAddressesArr.join(',');
          bccAddresses = bccAddressesArr.join(',');
        }

        this.formGroup = this._formBuilder.group({
          messageSender: [this.balSender ? this.balSender : '', [Validators.required]],
          messageRecipients: [addresses],
          messageCcRecipients: [ccAddresses],
          messageBccRecipients: [bccAddresses],
          messageSubject: [this.message ? this.message.subject : '', [Validators.required]],
          messagePatient: ['', [Validators.required]],
          messageBody: [this.message.body ? this.message.body : '', Validators.required],
          messageAccuseReception : [false],
        });
      }, 0);
    } else {
      this.formGroup = undefined;
    }
  }

  private _getMessageToSendFromForm(draftMode = false): MSSMessageToSend | undefined {
    const addresses: Array<MSSAddress> = [];
    let body: string;
    let subject: string;

    const currentUserStr = localStorage.getItem('currentUser');
    let currentUser: Utilisateur;
    if (currentUserStr && currentUserStr !== '') {
      currentUser = JSON.parse(currentUserStr) as Utilisateur;
    }

    if (this.formGroup) {
      addresses.push({
        email: this.balSender,
        type: MSSEnumTypeMail.FROM,
        name: currentUser && currentUser.prenom && currentUser.nom
          ? `${currentUser.prenom} ${currentUser.nom}` : undefined
      });

      const addressesStr = this.formGroup.get('messageRecipients').value as string;
      const addressesArr = addressesStr.split(',') as Array<string>;
      let isRecipient = false;
      for (let address of addressesArr) {
        address = address.trim();
        // if (address !== '' && address.match(MSS_EMAIL_REGEX) && addresses[0].email !== address) {
        if (address !== '' && address.match(MSS_EMAIL_REGEX)) {
          addresses.push({
            email: address,
            type: MSSEnumTypeMail.TO
          });
          isRecipient = true;
        } 
      }

      if (!isRecipient && !draftMode) {
        this._modalSrv.openAlert(
          this._viewContainerRef,
          'Erreur',
          'Au moins un destinataire est obligatoire pour envoyer un message'
        );
        return undefined;
      }

      const ccAddressesStr = this.formGroup.get('messageCcRecipients').value as string;
      const ccAddressesArr = ccAddressesStr.split(',') as Array<string>;
      for (let address of ccAddressesArr) {
        address = address.trim();
        if (address !== '' && address.match(MSS_EMAIL_REGEX) && addresses[0].email !== address) {
          addresses.push({
            email: address,
            type: MSSEnumTypeMail.CC
          });
        }
      }

      const bccAddressesStr = this.formGroup.get('messageBccRecipients').value as string;
      const bccAddressesArr = bccAddressesStr.split(',') as Array<string>;
      for (let address of bccAddressesArr) {
        address = address.trim();
        if (address !== '' && address.match(MSS_EMAIL_REGEX) && addresses[0].email !== address) {
          addresses.push({
            email: address,
            type: MSSEnumTypeMail.BCC
          });
        }
      }

      body = this.formGroup.get('messageBody').value as string;
      subject = this.formGroup.get('messageSubject').value as string;
    }

    const attachments: Array<MSSAttachment> = [];
    if (this.message && this.message.attachments && this.message.attachments.length > 0) {
      for (const attachment of this.message.attachments) {
        attachments.push(attachment);
      }
    }
    let rtd: MSSMessageToSend;
    rtd = {
      messageData: {
        addresses,
        attachments,
        body,
        isHtml: true,
        messageId: !this._replyType && this.message && this.message.messageId ? this.message.messageId : undefined,
        messageTransferedId: this._replyType && this.message && this.message.messageId ? this.message.messageId : undefined,
        replyType: this._replyType,
        isAccuse: this.formGroup.get('messageAccuseReception').value as boolean,
        subject
      }
    };

    console.log(rtd);

    /** Si un patient a été selectionné dans le formulaire */
    /** On modifie le titre si hors apicrypt*/
    const hasApicryptEmail = rtd.messageData.addresses.some(address => 
      address.type === 'TO' && address.email.includes('apicrypt')
    );

    if (this.currentMessagePatient) {
      rtd.patientInfo = this.currentMessagePatient;
      if (!subject.startsWith(MssMessageDisplayComponent.titlePrefix) && !hasApicryptEmail) {
        rtd.messageData.subject = `${MssMessageDisplayComponent.titlePrefix}${subject} ${this.currentMessagePatient.lastName} ${this.currentMessagePatient.firstName} ${this.currentMessagePatient.birthDate}`;
      }
    }

    if (draftMode && !rtd.messageData.subject) {
      rtd.messageData.subject = 'Draft message';
    }

    this._replyType = undefined;

    return rtd;
  }
}
